export const DEFAULT_COLOR = "var(--primary-color, blue)";
